import dynamic from "next/dynamic";

export const DynamicPhotoGalleryDialog = dynamic(() =>
  import("~/components/content/content-schema-render/div/photo-gallery/photo-gallery-dialog").then(
    module => module.PhotoGalleryDialog,
  ),
);
